import React, { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './slider.css'
import connect from "react-redux/es/connect/connect";
import { getNextCity, getPrevCity } from "../../ducks/cities";
import { cities } from '../../data/cities'
import { sendEvent } from "../../helpers/analytics";


class PlaceSlider extends Component {
  next = () => {
    this.slider.slickNext();
    this.props.getNextCity()
    sendEvent('window', 'click', 'arrows')
  }

  previous = () => {
    this.slider.slickPrev();
    this.props.getPrevCity()
    sendEvent('window', 'click', 'arrows')
  }

  render () {
    const { id } = this.props
    const settings = {
      centerMode: true,
      centerPadding: '0px',
      arrows: false,
      infinite: true,
      speed: 200,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: id,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    const {move} = this.props

    return (
      <div>
        <div className="place__slider" style={{transform: `translate(${move[0]}px, ${move[1]}px)`}}>
          <Slider {...settings} ref={c => (this.slider = c)} >

            {cities.map((city, index) => <div key={city.title}>
              <div className={`slide slide--${index}`} style={{backgroundImage: `url(${city.image})`}}>
              </div>
            </div>)}

          </Slider>
        </div>
        <div className="slider__buttons">
          <button className="button--prev" onClick={this.previous}></button>
          <button className="button--next" onClick={this.next}></button>
        </div>
      </div>
    )
  }
}


export default connect(
  null,
  { getNextCity, getPrevCity }
)(PlaceSlider)



// WEBPACK FOOTER //
// ./src/components/slider/slider.js